import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFolderFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3.25C3.92893 3.25 2.25 4.92893 2.25 7V17C2.25 19.0711 3.92893 20.75 6 20.75H18C20.0711 20.75 21.75 19.0711 21.75 17V9C21.75 6.92893 20.0711 5.25 18 5.25H12.1575C11.6152 5.25 11.2887 4.90524 10.9609 4.53061C10.2488 3.7168 9.22005 3.25 8.1387 3.25H6Z",
		fill: "currentColor"
	})
});
export { SvgIconFolderFill as ReactComponent };
